<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        SR Coverage Indicators Report
      </h2>
      <p class="tw-italic tw-text-gray-700">
        Download curated SR Coverage Indicators report.
      </p>
      <div class="mb-3">
        <span class="text-secondary tw-text-xs">Last Updated: {{ last_update || 'Loading...' }}</span>
      </div>
      <b-table :items="rows" :fields="fields" bordered striped responsive>
        <template #cell(household)="data">
          <button
            v-if="data.item.key !== 'A8' && data.item.key !== 'A9'"
            class="btn btn-link p-0"
            @click="downloadHousehold(data.item)"
          >
            Household
          </button>
        </template>
        <template #cell(cluster)="data">
          <b-link
            v-if="data.item.key !== 'A1'"
            href="#"
            @click.prevent="downloadCluster(data.item)"
          >
            Cluster
          </b-link>
        </template>
      </b-table>
    </b-container>


    <b-pagination
      v-if="totalItems"
      v-model="options.currentPage"
      :total-rows="options.totalRows"
      :per-page="options.perPage"
      align="right"
      size="sm"
      class="my-0"
    ></b-pagination>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import moment from 'moment-timezone';

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
  name: "SRCoverageIndicatorsReport",
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      last_update: null,
      fields: [
        { key: "report", label: "Report Name" },
        { key: "household", label: "Download" },
        { key: "cluster", label: "Download" }
      ],
      rows: [
        { report: "A1 - Consented Application Number", key: "A1" },
        { report: "A2 - Target Application Number", key: "A2" },
        { report: "A3 - Proportional Product Application Rate(PPAR)", key: "A3" },
        { report: "A4 - Household Coverage", key: "A4" },
        { report: "A5 - Consented Product Attrition Rate", key: "A5" },
        { report: "A6 - Target Product Placement Rate", key: "A6" },
        { report: "A7 - Consented Product Placement Rate", key: "A7" },
        { report: "A8 - Target Coverage based on Product Placement", key: "A8" },
        { report: "A9 - Cluster Coverage", key: "A9" }
      ]
    };
  },

  created() {
    this.get_last_updated_at();
  },

  methods: {
    get_last_updated_at() {
      const key = 'A1 - Consented Application Number';
      
      HTTP.get('/lib/get_last_updated_at/' + key)
        .then((response) => {
          if (response.data && response.data.last_update) {
            this.last_update = moment(response.data.last_update).tz(moment.tz.guess());
          } else {
            this.last_update = 'No timestamp found';
          }
        })
        .catch(() => {
          this.last_update = 'Timestamp not available';
        });
    },

    downloadHousehold(item) {
      const baseUrl = process.env.VUE_APP_AXIOS_BASE_URL;
      const downloadUrl = baseUrl + '/srilanka/analysis?download=1&analysis=' + item.key + '_household';
      
      HTTP.get(downloadUrl, { responseType: "blob" })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          
          // Append last_update timestamp to filename
          const timestamp = this.last_update ? '_' + this.last_update.format('YYYY-MM-DD') : '';
          fileLink.setAttribute("download", item.report + " Household" + timestamp + ".csv");
          
          document.body.appendChild(fileLink);
          fileLink.click();
          window.URL.revokeObjectURL(fileURL);
          document.body.removeChild(fileLink);
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
        });
    },

    downloadCluster(item) {
      const baseUrl = process.env.VUE_APP_AXIOS_BASE_URL;
      const downloadUrl = baseUrl + '/srilanka/analysis?download=1&analysis=' + item.key + '_cluster';
      
      HTTP.get(downloadUrl, { responseType: "blob" })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          
          // Append last_update timestamp to filename
          const timestamp = this.last_update ? '_' + this.last_update.format('YYYY-MM-DD') : '';
          fileLink.setAttribute("download", item.report + " Cluster" + timestamp + ".csv");
          
          document.body.appendChild(fileLink);
          fileLink.click();
          window.URL.revokeObjectURL(fileURL);
          document.body.removeChild(fileLink);
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
        });
    }
  }
};

</script>

<style></style>
